module.exports = __webpack_public_path__ + "img/TP.62161d2b.png";